import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const StationContext = createContext(null);

export function StationProvider({ children }) {
  const { user } = useAuth();
  const [stations, setStations] = useState([]);
  const [stationId, setStationIdState] = useState(() => localStorage.getItem("ft_station") || "all");

  const setStationId = (id) => {
    setStationIdState(id);
    localStorage.setItem("ft_station", id);
  };

  useEffect(() => {
    if (!user) return;
    api.get("/stations").then((r) => {
      setStations(r.data);
      const stored = localStorage.getItem("ft_station") || "all";
      if (stored !== "all" && !r.data.some((s) => s.id === stored)) {
        setStationId(r.data[0]?.id || "all");
      }
    }).catch(() => {});
  }, [user]);

  return (
    <StationContext.Provider value={{ stations, stationId, setStationId }}>
      {children}
    </StationContext.Provider>
  );
}

export const useStation = () =>
  useContext(StationContext) || { stations: [], stationId: "all", setStationId: () => {} };
